import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { profileData } from '../mock/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 bg-gradient-to-br from-[#030d12] via-[#04141c] to-[#061B24] text-white mt-20 border-t border-cyan-900/20">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">
              <span className="text-sky-300">David</span>
              <span className="text-blue-200"> Provenzani</span>
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Senior Commercial Leader with 25+ years of executive experience in renewable energy and infrastructure across MENA & GCC.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-sky-300">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/experience" className="text-gray-300 hover:text-sky-300 transition-colors text-sm">
                  Professional Experience
                </Link>
              </li>
              <li>
                <Link to="/education" className="text-gray-300 hover:text-sky-300 transition-colors text-sm">
                  Education
                </Link>
              </li>
              <li>
                <Link to="/awards" className="text-gray-300 hover:text-sky-300 transition-colors text-sm">
                  Awards & Mentions
                </Link>
              </li>
              <li>
                <Link to="/publications" className="text-gray-300 hover:text-sky-300 transition-colors text-sm">
                  Publications
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-sky-300 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-sky-300">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm">
                <Mail className="h-4 w-4 text-sky-400" />
                <a href={`mailto:${profileData.email}`} className="text-gray-300 hover:text-sky-300 transition-colors">
                  {profileData.email}
                </a>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Phone className="h-4 w-4 text-sky-400" />
                <a href={`tel:${profileData.phone}`} className="text-gray-300 hover:text-sky-300 transition-colors">
                  {profileData.phone}
                </a>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <MapPin className="h-4 w-4 text-sky-400" />
                <span className="text-gray-300">{profileData.location}</span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Linkedin className="h-4 w-4 text-sky-400" />
                <a
                  href={profileData.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-sky-300 transition-colors"
                >
                  LinkedIn Profile
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-blue-900/20 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} David Provenzani. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
